import { lazyOpenBizChatSidePaneFromDeeplink } from 'owa-bizchat-shared';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import type { MailboxInfo } from 'owa-client-types';

export interface mailCopilotRouteParameters {
    mailboxInfo: MailboxInfo;
    deeplink?: string;
}

export async function mailCopilotNavigationRouteHandler(
    params: mailCopilotRouteParameters
): Promise<void> {
    if (isGlobalFeatureEnabled('mon-copilot-bizchat')) {
        await lazyOpenBizChatSidePaneFromDeeplink.importAndExecute({
            source: 'MailRouteDeeplink',
            encodedDeepLink: params.deeplink,
            mailboxInfo: params.mailboxInfo,
        });
    }
}
